document.addEventListener('DOMContentLoaded', function () {
  const productHeader = document.querySelector('.product-header');
  const stickyAtb = document.querySelector('.product-action-sticky-atb');
  const form = document.getElementById('sticky-add-to-bag-form');
  const button = document.querySelector('button[name="sticky-atb"]');
  const progressBar = document.querySelector('.red-progress-bar');
  const variantSelector = document.querySelector('.product-variant-sticky-selector');
  const successText = document.querySelector('.success-text');
  const viewBagLink = document.querySelector('.view-bag-link');
  const mainForm = document.getElementById('add-to-bag-form');
  const smellMeForm = document.getElementById('smell-me-atb-form');
  const mainButton = document.querySelector('button[name="atb"]');
  const mainButtonText = mainButton?.querySelector('.button__text');
  const smellMeButton = document.querySelector('button[name="smell-me-btn"]');
  const smellMeButtonText = smellMeButton?.querySelector('.button__text');
  const buttonPrice = document.querySelector('.button__price');
  const recipientFormInputs = document.querySelectorAll('.recipient-form .input-container .field__input');
  const notifyBtn = document.querySelector('.notify button');
  const stickynotifyBtn = document.querySelector('.product-action-sticky-atb .sticky-notify-btn span');
  const exploreOtherScentsComponent = document.querySelector('.section-explore-other-scents');
  const giftCardStickyBtn = document.getElementById('giftCardStickyBtn');
  const productDescription = document.querySelector('.product__description');
  const personalisedLabelButton = document.querySelector('#personalised-label-button');
  const url = window.location.href;
  const productUrl = url.split('/products/')[1]?.split('?')[0];

  let lastScrollTop = 0;
  let isIntersecting = false;

  function addClass(element, ...classNames) {
    if (element) element.classList.add(...classNames);
  }

  function removeClass(element, ...classNames) {
    if (element) element.classList.remove(...classNames);
  }



  if (productUrl) {
    // Add the product to the recently viewed section
    fetch(`${productUrl}.js`)
    .then((response) => response.json())
    .then((productData) => {
      if (productData && productData.variants) {
        const variantId = productData.variants[0].id;
        klevu.dom.helpers.addClickedProductToCookie(variantId);
      }
    })
    .catch((error) => {
      console.error('Error fetching variant ID:', error);
    });
  }

  if (notifyBtn && stickynotifyBtn) {
    stickynotifyBtn.addEventListener('click', function () {
      notifyBtn.click();
    });
  }

  function scrollUserToInvalidGiftCardForm() {
    const recipientForm = document.querySelector('.gift-card-product');
    if (recipientForm) {
      recipientForm.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }

  // Utility Functions
  const toggleVisibility = (elements, action) => {
    elements.forEach((element) => {
      if (element) {
        element.classList.toggle('hidden', action === 'hide');
        element.classList.toggle('fade-out', action === 'hide');
        element.classList.toggle('fade-in', action === 'show');

        if (action === 'fade-out-animation') {
          element.classList.remove('opacity-0');
          element.classList.add('fade-out');
          setTimeout(() => {
            element.classList.add('opacity-0');
            element.classList.remove('fade-out');
            element.classList.add('hidden');
          }, 600);
        }
        if (action === 'fade-in-animation') {
          element.classList.remove('hidden');
          element.classList.remove('fade-out');
          element.classList.add('fade-in');
        }
      }
    });
  };

  const handleScroll = () => {
    const headerHeight = productHeader.offsetHeight;
    const scrollPosition = window.scrollY;
    const shouldShowStickyAtb = scrollPosition - 350 > headerHeight && !isIntersecting;

    if (shouldShowStickyAtb) {
      removeClass(stickyAtb, 'hidden');
      addClass(stickyAtb, 'opacity-100');
    } else {
      addClass(stickyAtb, 'hidden');
      removeClass(stickyAtb, 'opacity-100');
    }

    if (stickyAtb.classList.contains('opacity-100')) {
      if (scrollPosition > lastScrollTop) {
        addClass(stickyAtb, 'slide-up');
        removeClass(stickyAtb, 'slide-down');
      } else {
        if (scrollPosition === 0) {
          setTimeout(() => {
            addClass(stickyAtb, 'slide-down');
            removeClass(stickyAtb, 'slide-up');
          }, 150);
        } else {
          addClass(stickyAtb, 'slide-down');
          removeClass(stickyAtb, 'slide-up');
        }
      }
    } else {
      removeClass(stickyAtb, 'slide-up', 'slide-down');
    }
    lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
  };

  //Hide sticky ATB button when the free gifts component is scrolled into view
  const freeGiftComponentObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isIntersecting = entry.isIntersecting;

        if (isIntersecting) {
          removeClass(stickyAtb, 'opacity-100');
        }
      });
    },
    { threshold: 0.5 }
  );

  if (exploreOtherScentsComponent) {
    freeGiftComponentObserver.observe(exploreOtherScentsComponent);
  }

  window.addEventListener('scroll', () => {
    if (exploreOtherScentsComponent) {
      const componentTop = exploreOtherScentsComponent.getBoundingClientRect().top + window.scrollY;
      isIntersecting = window.scrollY >= componentTop - 600;
    }
  });

  const handleProgressBarAnimation = () => {
    progressBar.classList.toggle('red-progress-bar--grow-animation');
    progressBar.classList.toggle('red-progress-bar--shrink-animation');
  };

  const getStorageKey = (productId, key) => `${productId}_${key}`;

  const retrievePersonalization = (productId) => {
    const line1 = localStorage.getItem(getStorageKey(productId, 'line-1'));
    const line2 = localStorage.getItem(getStorageKey(productId, 'line-2'));
    return { line1, line2 };
  };

  const addToCart = async (form) => {
    const sellingPlanId = window.selectedSellingPlan ? window.selectedSellingPlan.id : '';
    const productId = form.querySelector('[name="id"]').value;
    const { line1, line2 } = retrievePersonalization(productId);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: form.querySelector('[name="id"]').value,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: {
              'Personalised Line 1': line1,
              'Personalised Line 2': line2,
            },
          },
        ],
      }),
    });
    clearGiftCardFormField();
    return response.json();
  };

  // Event Handlers
  const handleSubmit = (event) => {
    event.preventDefault();

    const isValid = validateGiftCardForm();
    if (!isValid) {
      return;
    }

    const formData = new FormData(form);
    const productId = formData.get('id');
    const { line1, line2 } = retrievePersonalization(productId);

    if (personalisedLabelButton && !line1 && !line2) {
      const customEvent = new CustomEvent('emptyInputs');
      document.dispatchEvent(customEvent);
      if (productDescription) {
        productDescription.scrollIntoView({
          behavior: 'smooth',
        });
      }
      return;
    }

    if (button && progressBar && successText && viewBagLink) {
      progressBar.classList.remove('red-progress-bar--shrink-animation');
      progressBar.classList.add('red-progress-bar--grow-animation');

      toggleVisibility([form, variantSelector], 'fade-out-animation');
      setTimeout(() => toggleVisibility([successText, viewBagLink], 'fade-in-animation'), 600);

      progressBar.addEventListener('animationend', handleProgressBarAnimation, { once: true });

      setTimeout(() => {
        toggleVisibility([successText, viewBagLink], 'fade-out-animation');
        setTimeout(() => toggleVisibility([form, variantSelector], 'fade-in-animation'), 1200);
      }, 3000);
      setTimeout(async () => {
        try {
          await addToCart(form);
          await updateCartView();
        } catch (error) {
          console.error('Error adding to cart:', error);
        }
      }, 3000);
    }
  };

  const validateGiftCardForm = () => {
    let recipientForm = document.querySelector('.recipient-form');
    let isValid = true;
    const inputs = document.querySelectorAll('.input-container .field__input');
    if (recipientForm) {
      inputs.forEach((input) => {
        const isFieldValid = validateInputFormField(input);
        isValid = isValid && isFieldValid;
      });
    }
    if (!isValid) {
      scrollUserToInvalidGiftCardForm();
    }
    return isValid;
  };

  const validateInputFormField = (input) => {
    const inputType = input.getAttribute('type');
    const value = input.value.trim();

    const parentField = input.closest('.recipient-fields__field');

    if (inputType === 'text') {
      if (value === '') {
        parentField.classList.add('error', 'group/field');
        return false;
      } else {
        parentField.classList.remove('error', 'group/field');
      }
    } else if (inputType === 'email') {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === '') {
        parentField.classList.add('error', 'group/field');
        return false;
      } else if (!emailPattern.test(value)) {
        parentField.classList.add('error', 'group/field');
        return false;
      } else {
        parentField.classList.remove('error', 'group/field');
      }
    }
    return true;
  };

  const validateGiftFieldOnFocus = async (event) => {
    validateInputFormField(event.target);
  };

  const clearGiftCardFormField = () => {
    if (recipientFormInputs) {
      recipientFormInputs.forEach((input) => {
        input.value = '';
      });
    }
  };

  const handleAddToCart = async (event, currentForm, atbButton, buttonText, displayBtnAnimation) => {
    event.preventDefault();
    const isValid = validateGiftCardForm();
    if (!isValid) {
      return;
    }

    // Retrieve the product ID from the form or other source
    const formData = new FormData(currentForm);
    const productId = formData.get('id');
    const { line1, line2 } = retrievePersonalization(productId);

    if (personalisedLabelButton && !line1 && !line2) {
      const customEvent = new CustomEvent('emptyInputs');
      document.dispatchEvent(customEvent);
      return;
    }

    if (mainButton) {
      buttonText.textContent = 'ADDING...';
      mainButton.classList.add('progress-bar-animation');
      const sellingPlanId = window.selectedSellingPlan ? window.selectedSellingPlan.id : '';
      const data = {
        items: [
          {
            id: productId,
            quantity: formData.get('quantity') || 1,
            selling_plan: sellingPlanId,
            properties: {
              'Recipient name': formData.get('properties[Recipient name]'),
              'Recipient email': formData.get('properties[Recipient email]'),
              Message: formData.get('properties[Message]'),
              __shopify_send_gift_card_to_recipient: formData.get('properties[__shopify_send_gift_card_to_recipient]'),
              'Personalised Line 1': line1,
              'Personalised Line 2': line2,
            },
          },
        ],
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(data),
        });
        const result = await response.json();

        if (result.status) {
          buttonText.textContent = result.description;
          buttonPrice.classList.add('hidden');
          setTimeout(() => {
            buttonText.textContent = 'ADD TO BAG';
            atbButton.classList.remove('progress-bar-animation');
            buttonPrice.classList.remove('hidden');
            clearGiftCardFormField();
          }, 3000);
        } else {
          toggleVisibility([variantSelector, form], 'hide');
          toggleVisibility([successText, viewBagLink], 'show');
          setTimeout(() => {
            buttonText.textContent = 'ADD TO BAG';
            atbButton.classList.remove('progress-bar-animation');
            clearGiftCardFormField();
          }, 1200);

          setTimeout(() => {
            stickyAtb.classList.replace('md:top-spacing-7xl', 'md:top-spacing-11xl');
            stickyAtb.classList.add('opacity-100');
            stickyAtb.classList.remove('hidden');
            if (currentForm.getAttribute('id') == 'smell-me-atb-form') {
              stickyAtb.classList.add('z-9999999');
            }
          }, 1600);

          setTimeout(() => {
            stickyAtb.classList.remove('opacity-100');
            stickyAtb.classList.remove('z-9999999');
            setTimeout(() => {
              stickyAtb.classList.replace('md:top-spacing-11xl', 'md:top-spacing-7xl');
              toggleVisibility([successText, viewBagLink], 'hide');
              toggleVisibility([variantSelector, form], 'show');
            }, 600);
          }, 6000);

          await updateCartView();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }
  };

  // Event Listeners
  if (productHeader && stickyAtb) {
    window.addEventListener('scroll', handleScroll);
  }

  if (form) {
    form.addEventListener('submit', handleSubmit);
  }

  if (mainForm) {
    mainForm.addEventListener('submit', (event) => handleAddToCart(event, mainForm, mainButton, mainButtonText, true));
  }

  if (smellMeForm) {
    smellMeForm.addEventListener('submit', (event) =>
      handleAddToCart(event, smellMeForm, smellMeButton, smellMeButtonText, false)
    );
  }

  if (recipientFormInputs) {
    recipientFormInputs.forEach((recipientFormInput) => {
      recipientFormInput.addEventListener('focusout', validateGiftFieldOnFocus);
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.classList.contains('ReactModal__Overlay') || node.classList.contains('Servicify-Overlay'))
          ) {
            document.body.classList.add('overflow-hidden', 'fixed');
          }
        });

        mutation.removedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.classList.contains('ReactModal__Overlay') || node.classList.contains('Servicify-Overlay'))
          ) {
            const remainingReactModal = document.querySelector('.ReactModal__Overlay');
            const remainingServicifyOverlay = document.querySelector('.Servicify-Overlay');

            if (!remainingReactModal && !remainingServicifyOverlay) {
              document.body.classList.remove('overflow-hidden', 'fixed');
            }
          }
        });
      }
    });
  });

  // Start observing the body for changes
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Need to reload the page after event is added to the cart for it to appear in the mini bag
  const servicifyButtonsObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check for the button with the class "servicify-modal-close"
            if (node.classList.contains('servicify-modal-close')) {
              handleServicifyButtonClick(node);
            }

            // Check for nested elements
            const targetButton = node.querySelector('[data-servicify="continue-shopping"], .servicify-modal-close');
            if (targetButton) {
              handleServicifyButtonClick(targetButton);
            }
          }
        });
      }
    });
  });

  document.addEventListener('imageLoaded', (e) => {
    const container = e.target.closest('.hover-image-container');
    const badge = container?.querySelector('.product-badge');
    if (badge) badge.classList.remove('opacity-0');
  });

  // Function to attach the click listener to the Servicify buttons
  function handleServicifyButtonClick(button) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      location.reload();
    });
  }

  // Start observing the DOM for dynamically added elements
  servicifyButtonsObserver.observe(document.body, { childList: true, subtree: true });

  // Check if the page contains the .template-product class
  if (!document.body.classList.contains('template-product')) return;

  // Selectors
  const SELECTORS = {
    groupTabs: '.group\\/tabs__li',
    headerSolid: '.header-solid',
  };

  // Utility: Check if the screen is smaller than 1024px
  const isSmallScreen = () => window.innerWidth < 1024;

  // Utility: Hide header on small screens
  const hideHeader = () => {
    const headerSolid = document.querySelector(SELECTORS.headerSolid);
    if (headerSolid && isSmallScreen()) {
      headerSolid.classList.add('!opacity-0', '!z-0');
    }
  };

  // Event: Handle group tab clicks
  document.querySelectorAll(SELECTORS.groupTabs).forEach((tab) => {
    tab.addEventListener('click', () => {
      // Scroll to the top only on larger screens
      if (!isSmallScreen()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      hideHeader();
    });
  });
});
